<template>
  <el-tooltip placement="top">
    <template #content>
      {{ $t('c.table.columnTooltipCPL') }}
      <br />
      <template v-if="cpl !== undefined">
        <span v-for="[key, value] in cplEntries" :key="key">
          <span>Avg. {{ key }}: {{ value | toFixed(2) }}</span>
          <br />
        </span>
      </template>
    </template>
    <span>{{ $t('c.table.columnNameCPL') }}</span>
  </el-tooltip>
</template>

<script>
export default {
  name: 'VCplTooltip',
  props: {
    cpl: {
      type: [Object, Number]
    }
  },
  computed: {
    cplEntries() {
      if (typeof this.cpl === 'object') {
        return Object.entries(this.cpl).map(([key, value]) => {
          if (key === 'CMS') return ['GDN', value]
          return [key, value]
        })
      }
      return [['CPL', this.cpl]]
    }
  }
}
</script>
